import React from 'react';
import { GridRowParams } from '@mui/x-data-grid';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { getGridStringOperators } from '@mui/x-data-grid';
import { ChipSet } from '../components/ChipSet';

const stringOperators = getGridStringOperators().filter(op =>
  ['contains'].includes(op.value),
);
export const OrgsColumns = [
  {
    field: 'name',
    headerName: 'Team Name',
    flex: 1,
    resizable: false,
    disableColumnMenu: true,
    filterOperators: stringOperators,
  },
  {
    field: 'description',
    headerName: 'Description',
    flex: 1,
    resizable: false,
    disableColumnMenu: true,
    filterOperators: stringOperators,
  },
  {
    field: 'usersCount',
    headerName: 'User Count',
    flex: 1,
    resizable: false,
    disableColumnMenu: true,
    filterOperators: stringOperators,
  },
  {
    flex: 1,
    minWidth: 435,
    field: 'orgAdminEmails',
    headerName: 'Team Admins',
    resizable: true,
    disableColumnMenu: true,
    sortable: false,
    filterOperators: stringOperators,
    renderCell: (params: GridRowParams) => (
      <ChipSet max={1} values={params.row.orgAdminEmails} />
    ),
  },
  {
    flex: 1,
    field: 'edit',
    headerName: 'Edit',
    resizable: true,
    disableColumnMenu: true,
    sortable: false,
    filterable: false,
    renderCell: (
      params: GridRowParams & { colDef: { onClick: (rowId: string) => {} } },
    ) => (
      <IconButton
        type="button"
        onClick={e => {
          e.stopPropagation();
          params.colDef.onClick(params.row.id);
        }}
      >
        <EditIcon color="primary" />
      </IconButton>
    ),
  },
];
